import { getLogger } from '@confluence/logger';
import { type LoomEntryPointVariant } from '@confluence/loom-utils';

const logger = getLogger('useRovoLoomScriptEntryPoint');

/**
 * @param entryPointVariant VERY important `CO_USE` or `CROSS_JOIN` will determine
 * the type of CTA that shows in the rovo chat
 * @returns `openRovoLoomScript` the function that will handle opening ROVO chat in the
 * sidebar with the prompt for a loom script.
 */
export const useRovoLoomScriptEntryPoint = (
	entryPointVariant: LoomEntryPointVariant['entryPointVariant'],
) => {
	// TODO implement ROVO triggers here
	return {
		openRovoLoomScript: () => {
			logger.debug`[ReadTimeDropdown] called openRovoLoomScript with ${entryPointVariant}`;
			void entryPointVariant;
		},
	};
};
